module.exports = __webpack_public_path__ + "static/media/rnr-image-2.187b5835.png";